import React from 'react';
const CHECKOUT_URL = 'https://italia.edulabs.online/cart/43353828622454:1';
export function PricingSection() {
  const firePixel = () => {
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'AddToCart', {
        content_name: 'Volley Pronto Bundle',
        content_type: 'product',
        value: 19,
        currency: 'EUR'
      });
    }
  };
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-163">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(37,99,235,0.08) 0%, transparent 70%)'
    }} data-id="element-164"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-165"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-166">
        <h2 className="text-3xl sm:text-6xl font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-167">
          L'Offerta "Volley Pronto"
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/50 shadow-[0_0_50px_rgba(37,99,235,0.15)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-168">
          {/* Glowing Border Effect */}
          <div className="absolute inset-0 rounded-xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-primary/50 to-transparent opacity-50 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-169"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(250,204,21,0.5)] border border-white/20" data-id="element-170">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <p className="text-sm sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-171">
            VALORE TOTALE DEI CONTENUTI:
          </p>

          {/* Line items */}
          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-172">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-173">
              <span data-id="element-174">Percorso Tecnico (6 Tomi Completi)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-175">
                € 127
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-176">
              <span data-id="element-177">Registro del Coach e Schede Tattiche</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-178">
                € 57
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-179">
              <span data-id="element-180">Archivio 101 Drills Pro</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-181">
                € 47
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-182">
              <span data-id="element-183">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-184">
                € 67
              </span>
            </div>

            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-185">
              <span data-id="element-186">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-187">€ 298</span>
            </div>
          </div>

          {/* Price reveal */}
          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-primary/5 to-transparent border border-white/10 py-6 sm:py-10 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-188">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-189"></div>

            {/* Original price + discount badge */}
            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2 sm:mb-4" data-id="element-190">
              <span className="text-text-sec line-through text-base sm:text-2xl font-medium" data-id="element-191">
                € 298,00
              </span>
              <span className="bg-cta-green/20 text-cta-green font-black text-[10px] sm:text-sm px-2 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-192">
                91% OFF
              </span>
            </div>

            {/* Big price */}
            <div className="text-yellow-400 font-black text-5xl sm:text-8xl tracking-tighter transition-all leading-none drop-shadow-[0_0_20px_rgba(250,204,21,0.4)]" data-id="element-193">
              € 19
            </div>

            <div className="text-text-sec text-xs sm:text-base font-medium mt-2 sm:mt-3 flex items-center justify-center gap-2" data-id="element-194">
              <span data-id="element-195">💳 Pagamento unico</span>
              <span data-id="element-196">•</span>
              <span data-id="element-197">⚡ Accesso immediato</span>
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/20 animate-pulse-composited mx-auto mb-3 sm:mb-6" data-id="element-198">
            ⏰ Prezzo speciale di lancio — salirà a breve
          </span>

          {/* CTA Button */}
          <a href={CHECKOUT_URL} onClick={firePixel} className="btn-primary-pulse block w-full text-center bg-cta-green text-gray-900 font-black text-[17px] sm:text-2xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_0_40px_rgba(16,185,129,0.4)] border border-white/20 mb-6 pt-[25px] pb-[25px]" data-id="element-199">
            <span className="hidden sm:inline" data-id="element-200">
              🚀 SÌ! VOGLIO IL KIT COMPLETO — € 19
            </span>
            <span className="sm:hidden text-[18px]" data-id="element-201">
              🚀 VOGLIO IL KIT — € 19
            </span>
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-202">
            <span data-id="element-203">⚡ Accesso Immediato</span>
            <span data-id="element-204">•</span>
            <span data-id="element-205">💳 Un solo Pagamento</span>
            <span data-id="element-206">•</span>
            <span data-id="element-207">🛡️ Garanzia 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}